export default __webpack_public_path__ + "static/media/ic_close_circle.f301b28a.svg";